/**
 * MobileBottomAds — Mobil/tablet-də sidebar reklamları səhifənin altında göstərir.
 * Desktop-da (>= 1480px) gizlidir — orada GlobalSidebars işləyir.
 * Sıra: əvvəl SOL (SIDEBAR_LEFT), sonra SAĞ (SIDEBAR_RIGHT).
 */
import AdBanner from './AdBanner'

export default function MobileBottomAds() {
  return (
    <div className="mobile-bottom-ads" style={{
      display: 'none', // CSS override aşağıda
      gap: '1rem',
      padding: '1rem 1.5rem',
      maxWidth: 800,
      margin: '0 auto',
    }}>
      <AdBanner placement="SIDEBAR_LEFT"  variant="sidebar" />
      <AdBanner placement="SIDEBAR_RIGHT" variant="sidebar" />

      <style>{`
        @media (max-width: 1479px) {
          .mobile-bottom-ads { display: flex !important; flex-direction: column; }
        }
      `}</style>
    </div>
  )
}
